export enum ArticleContentStructureType {
  HEADING = 'heading',
  PARAGRAPH = 'paragraph',
  IMAGE = 'image',
  UNORDERED_LIST = 'unordered-list',
  ORDERED_LIST = 'ordered-list',
  HTML = 'html',
}

export interface ArticleContentStructure extends Record<string, unknown> {
  type: ArticleContentStructureType
  content: string | string[]
  class?: string
}
